var FieldName;
(function (FieldName) {
    FieldName["CardNumber"] = "cardNumber";
    FieldName["CardCvv"] = "cardCvv";
    FieldName["CardHolder"] = "cardHolder";
    FieldName["CardExpiryDate"] = "cardExpiryDate";
})(FieldName || (FieldName = {}));
export default FieldName;
